/*!
 * (c) Trimble Inc. All rights reserved
 */
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map, catchError } from 'rxjs/operators';
import { of, from } from 'rxjs';

import {
  ApplyPreferences,
  ApplyPreferencesSuccess,
  GetElectricalShortcutsModifiersInformation,
  GetElectricalShortcutsModifiersInformationSuccess,
  GetElectricalSystemsInformation,
  GetElectricalSystemsInformationSuccess,
  GetInvalidShortcuts,
  GetInvalidShortcutsSuccess,
} from './electrical-settings-actions';

import { BackendService } from '../../../../../utils/src';

@Injectable()
export class ElectricalSettingsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly backendService: BackendService
  ) {}

  getElectricalSystemsInformation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetElectricalSystemsInformation),
      concatMap(() =>
        this.backendService.getElectricalSystemsInformation().pipe(
          map((data) =>
            GetElectricalSystemsInformationSuccess({
              electricalInformation: data
            })
          ),
          catchError((error) => of(error))
        )
      )
    )
  );

  getElectricalShortcutsModifiersInformation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetElectricalShortcutsModifiersInformation),
      concatMap(() =>
        this.backendService.getElectricalShortcutsModifiersInformation().pipe(
          map((data) =>
            GetElectricalShortcutsModifiersInformationSuccess({ shortcuts: data })
          ),
          catchError((error) => of(error))
        )
      )
    )
  );

  getInvalidShortcuts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetInvalidShortcuts),
      concatMap((action) =>
        this.backendService.onApplyClick(action.electricalSettings).pipe(
          map((data) => GetInvalidShortcutsSuccess({ invalidShortcuts: data })),
          catchError((error) => of(error))
        )
      )
    )
  );

  applyPreferences$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ApplyPreferences),
      concatMap((action) =>
        of(this.backendService.onApplyPreferencesClick(action.electricalSettings)).pipe(
          map(() => ApplyPreferencesSuccess()),
          catchError((error) => of(error))
        )
      )
    )
  );
}